export default {
  category_id: [
    { required: true, message: '请选择分类', trigger: 'change' }
  ],
  brand_id: [
    { required: true, message: '请选择品牌', trigger: 'change' }
  ],
  // compare_url: [
  //   { required: true, message: '请填写京东/天猫链接', trigger: 'blur' },
  //   { max: 255, message: '链接过长，请精简后输入', trigger: 'blur' }
  // ],
  title: [
    { required: true, message: '请填写商品标题', trigger: 'blur' },
    { min: 5, max: 60, message: '标题应为 5 至 60 个字符，标题过长可以使用副标题做补充', trigger: 'blur' }
  ],
  sub_title: [
    { max: 80, message: '副标题不能超过80个字符', trigger: 'blur' }
  ],
  picture: [
    { required: true, message: '商品主图不能为空', trigger: 'change' }
  ],
  detail: [
    { required: true, message: '商品详情页不能为空', trigger: 'change' }
  ]
};